<template>
  <div
    v-if="facebookAppId"
    :class="{ mastery: mastery }"
    class="facebook-component-container"
    @click="authenticate()"
  >
    <icon
      v-if="mastery"
      :name="'facebook'"
    />
    {{ buttonText }}
  </div>
</template>

<script>
import Authentication from '@/mixins/authentication';
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  mixins: [Authentication],
  props: {
    createAccount: {
      type: Boolean,
      default: false,
    },
    mastery: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonText() {
      return this.createAccount ? 'Create Account with Facebook' : 'Log In with Facebook';
    },
    facebookAppId() {
      return this.$store.getters['app/facebookAppId'];
    },
  },
  methods: {
    authenticate() {
      // FB may not have loaded yet
      if (typeof(FB) === 'undefined' || FB === null) return;
      const trackingParams = this.collectTrackingParams();
      FB.login((response) => {
        if (response.status === 'connected' && response.authResponse.accessToken) {
          this.loading = true;
          this.$store.dispatch('session/signIn', [{ accessToken: response.authResponse.accessToken, ...trackingParams }]).then(response => {
            if (this.$store.getters['session/currentUser'].newFromFacebook) {
              this.$analytics.events.signUp(this.$store, 'Facebook');
              this.postSignUp();
            } else {
              this.redirectAfterSignIn();
            }

            this.$notify({
              group: 'notifications',
              text: 'You are now logged in',
              type: 'success',
            });
          }).catch(e => {
            this.errorNotification();
            this.loading = false;
          });
        } else {
          this.errorNotification();
        }
      }, { scope: 'email' });
    },
    errorNotification() {
      this.$notify({
        group: 'notifications',
        text: 'Facebook Authentication Failed',
        type: 'error',
      });
    },
  },
};
</script>
<style lang='scss' scoped>
  .facebook-component-container {
    background-color: #3b5998;
    border-radius: 4px;
    box-sizing: border-box;
    color: white;
    cursor: pointer;
    font-size: rem-calc(14);
    font-weight: $semi-bold;
    margin-bottom: rem-calc(16);
    padding: rem-calc(12);
    text-align: center;

    &.mastery {
      align-items: center;
      border-radius: 24px;
      display: flex;
      height: 44px;
      justify-content: center;
      letter-spacing: 0.5px;
      text-transform: uppercase;

      img {
        height: rem-calc(20);
        margin-right: rem-calc(12);
        width: rem-calc(20);
      }
    }
  }
</style>
